import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
function useReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => el.classList.add('in-view'), delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.05
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function Footer() {
  const ctaRef = useReveal();
  const bottomRef = useReveal(200);
  return <footer className="w-full pt-24 pb-10" style={{
    background: 'var(--accent)'
  }} data-id="element-39">
      <div className="content-wrap px-6 md:px-12" data-id="element-40">
        {/* Big CTA */}
        <div className="relative pt-16 mb-20" data-id="element-41">
          <div ref={ctaRef} className="reveal" data-id="element-42">
            {/* Mobile-only smiley sticker */}
            <img src="https://cdn.magicpatterns.com/uploads/7zsH2YgGWAmC9qnBqzAT5r/image.png" alt="" className="block md:hidden mb-6" style={{
            width: 80,
            height: 80,
            objectFit: 'contain'
          }} data-id="element-43" />
            <p className="text-xs tracking-[0.2em] uppercase mb-8 font-[300]" style={{
            color: 'rgba(255,255,255,0.6)'
          }} data-id="element-44">
              Let's work together
            </p>
            <div className="flex flex-col gap-4" data-id="element-45">
              <h2 className="font-display tracking-[-0.03em] leading-tight text-[clamp(2rem,5vw,3.5rem)] font-[250]" style={{
              color: '#fff'
            }} data-id="element-46">
                Good ideas don't wait.
                <br data-id="element-47" />
                <span style={{
                color: 'rgba(255,255,255,0.7)',
                fontFamily: "'Aspekta', sans-serif",
                fontStyle: 'normal'
              }} data-id="element-48">
                  Go Launch.
                </span>
              </h2>
              <div className="mt-6" data-id="element-49">
                <button data-cal-link="go.launch/30min" data-cal-namespace="30min" data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}' className="inline-flex items-center gap-2 font-medium text-sm px-6 py-3 rounded-full cursor-pointer transition-colors duration-200 group" style={{
                background: '#fff',
                color: 'var(--accent)',
                border: 'none',
                fontFamily: 'inherit'
              }} onMouseEnter={e => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.9)';
              }} onMouseLeave={e => {
                e.currentTarget.style.background = '#fff';
              }} data-id="element-50">
                  Start a conversation
                  <ArrowUpRightIcon size={12} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" data-id="element-51" />
                </button>
              </div>
            </div>
          </div>

          {/* Yellow post-it note */}
          <div className="hidden md:flex" style={{
          position: 'absolute',
          right: 48,
          top: '58%',
          transform: 'translateY(-50%) rotate(2.5deg)',
          width: 180,
          height: 180,
          background: '#FEF08A',
          borderRadius: 4,
          padding: 16,
          flexDirection: 'column',
          justifyContent: 'space-between',
          boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
          userSelect: 'none'
        }} data-id="element-52">
            <p style={{
            fontSize: 18,
            fontWeight: 500,
            color: '#1a1a2e',
            lineHeight: 1.4,
            margin: 0
          }} data-id="element-53">
              Let's build!!!
            </p>
            <p style={{
            fontSize: 11,
            color: '#1a1a2e',
            opacity: 0.5,
            margin: 0,
            fontWeight: 300,
            fontFamily: "'Aspekta', sans-serif",
            letterSpacing: '0.04em'
          }} data-id="element-54">
              GoLaunch
            </p>
          </div>
        </div>

        {/* Footer bottom */}
        <div ref={bottomRef} className="reveal flex flex-row items-center justify-between gap-4 border-t pt-8" style={{
        borderColor: 'rgba(255,255,255,0.2)'
      }} data-id="element-55">
          <div className="flex items-center gap-4" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/ihQUXxQBv8WxuR74FiSFNs/image.png" alt="GoLaunch" style={{
            height: 20,
            width: 'auto',
            opacity: 0.7,
            filter: 'brightness(0) invert(1)'
          }} data-id="element-57" />
            <span style={{
            color: 'rgba(255,255,255,0.3)'
          }} data-id="element-58">
              —
            </span>
            <span className="text-xs font-[300]" style={{
            color: 'rgba(255,255,255,0.6)'
          }} data-id="element-59">
              © {new Date().getFullYear()}
            </span>
          </div>
          <a href="#" onClick={e => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="text-xs font-[300] transition-colors duration-200" style={{
          color: 'rgba(255,255,255,0.6)'
        }} onMouseEnter={e => e.currentTarget.style.color = '#fff'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'} data-id="element-60">
            Back to top ↑
          </a>
        </div>
      </div>
    </footer>;
}